module.exports = __webpack_public_path__ + "static/media/partnerships.fb7003b8.svg";